export const LIBRE = 'Libre';
export const LIMITE_AU_PAIEMENT_COMPTANT = 'LimiteAuPaiementComptant';
export const TOTAL = 'Total';

export const LEVEL_BLOCAGE = [
  { key: LIBRE, libelle: 'levelBlocage.libre' },
  { key: LIMITE_AU_PAIEMENT_COMPTANT, libelle: 'levelBlocage.limitePaiementComptant' },
  { key: TOTAL, libelle: 'levelBlocage.total' },
];
